import { useEffect } from 'react';
import { ArrowUpRight, Check, History, Sparkles } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { UPDATE_LOGS } from '../lib/update-logs';
import '../update-logs.css';

const releaseDate = (date: string) => new Intl.DateTimeFormat('en-US', {
  month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC',
}).format(new Date(`${date}T12:00:00Z`));

export function UpdateLogs() {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    let id: string;
    try { id = decodeURIComponent(hash.slice(1)); } catch { return; }
    // Wait for the app's route-change scroll reset before positioning this entry.
    const frame = requestAnimationFrame(() => document.getElementById(id)?.scrollIntoView({ block: 'start' }));
    return () => cancelAnimationFrame(frame);
  }, [hash]);
  return <div className="updates-page">
    <header className="updates-heading">
      <div>
        <span className="eyebrow"><History size={14} /> THE SOONSCREENER JOURNAL</span>
        <h1>Update logs</h1>
        <p>New tools, better insights and the details behind each update. The latest is always first.</p>
      </div>
      <div className="updates-brand" aria-hidden="true"><img src="/brand/owl.svg" width="88" height="88" alt="" /></div>
    </header>

    <ol className="updates-timeline" aria-label="Soonscreener updates, newest first">
      {UPDATE_LOGS.map((entry, index) => <li className="updates-release" key={entry.id} id={entry.id}>
        <div className="updates-date">
          <span className="updates-timeline-dot" aria-hidden="true" />
          <time dateTime={entry.date}>{releaseDate(entry.date)}</time>
          {index === 0 && <span className="updates-latest"><Sparkles size={11} /> Latest update</span>}
        </div>
        <article className={`updates-card${index === 0 ? ' updates-card-latest' : ''}`} aria-labelledby={`${entry.id}-title`}>
          <div className="updates-release-heading">
            <span className="updates-release-number" aria-hidden="true">{String(UPDATE_LOGS.length - index).padStart(2, '0')}</span>
            <h2 id={`${entry.id}-title`}>{entry.title}</h2>
            <Link className="updates-anchor" to={`#${entry.id}`} aria-label={`Link to ${entry.title}`} title="Link to this update">#</Link>
          </div>
          <p className="updates-summary">{entry.summary}</p>
          <ul className="updates-highlights">
            {entry.highlights.map(highlight => <li key={highlight.title}>
              <span className="updates-check" aria-hidden="true"><Check size={14} /></span>
              <div><h3>{highlight.title}</h3><p>{highlight.description}</p></div>
            </li>)}
          </ul>
          {entry.link && <Link className="updates-release-link" to={entry.link.to}>{entry.link.label}<ArrowUpRight size={14} /></Link>}
        </article>
      </li>)}
    </ol>

    <footer className="updates-footnote"><span className="live-dot" aria-hidden="true" /> Built on Soon. Growing with the ecosystem.</footer>
  </div>;
}
